import React from "react";
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

function AuditDetailsModal({ onClose, audit, auditType }: any) {
  return (
    <>
      <Modal show={true} backdrop="static" animation={false} size="lg">
        <Modal.Header closeButton={true} onHide={onClose}>
          <Modal.Title>Audit Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row mb-3">
            <div className="col-12">
              <div className="row my-2">
                <div className="col-4"><strong>Company:</strong></div>
                <div className="col-8">{(audit.company || {}).name || '-'}</div>
              </div>
              <div className="row my-2">
                <div className="col-4"><strong>Associate Company:</strong></div>
                <div className="col-8">{(audit.associate_company || {}).name || '-'}</div>
              </div>
              <div className="row my-2">
                <div className="col-4"><strong>Location:</strong></div>
                <div className="col-8">{(audit.location || {}).name || '-'}</div>
              </div>
              {auditType == "vendor_location" && <>
                <div className="row my-2">
                  <div className="col-4"><strong>Vendor Category:</strong></div>
                  <div className="col-8">{(audit.vendor_category || {}).name || '-'}</div>
                </div>
                <div className="row my-2">
                  <div className="col-4"><strong>Vendor:</strong></div>
                  <div className="col-8">{(audit.vendor_registration || {}).vendor_name || '-'}</div>
                </div>
              </>}
              <div className="row my-2">
                <div className="col-4"><strong>Month & Year:</strong></div>
                <div className="col-8">{audit.month} ({audit.year})</div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-end">
          <Button variant="outline-secondary" onClick={onClose} className="btn btn-outline-secondary">
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default AuditDetailsModal;
